import React, { useState } from "react";
import { fechaActual, HoraActual } from "../hooks/UseDate";
import { postSelectCambiarEstadoPaciente, postUpdateConsecutivo, postValidarProcedimientoMedico, postValidarProcedimientoQueTengaMedico } from "../services/PaginaRuta";
import ModalConfirmarMedicoProcedimiento from "./ModalConfirmarMedicoProcedimiento";
import ModalNoTieneProcedimientosQX from "./ModalNoTieneProcedimientosQX";

const TablaSeleccionServicioAmbulatorio = ({item,user,setmodalOnSeleccionServicio,passChildCambioDeEstado,setmodalOnConfirmar,procedimientosNoTinenenMedico, validarQueTenganProcedimientos}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const [modalOnVerificarMedico, setmodalOnVerificarMedico]=useState(false)
    const [modalOnNoTieneProcedimiento, setmodalOnNoTieneProcedimiento]=useState(false)

    const handleOnclickConfirmarConsecutivo=()=>{      
        
        if(validarQueTenganProcedimientos){
          if(procedimientosNoTinenenMedico.length > 0){
            setmodalOnVerificarMedico(true)         
  
          }else{          
                      const updateCon={
                        ProEsta: "2",
                        ProCtvIn: item.TmCtvIng,
                        PfcHrCnf: `${fechaActual()} ${HoraActual()}`,
                        PUsrConf: usuarioInfo.UsuarioEncriptado,
                        ProEmpCod: usuarioInfo.Empresa,
                        ProMCDpto: usuarioInfo.Sede,
                        ProCirCod: user.ProCirCod
                    }
                    //console.log(updateCon,'fechaaaaaaaaaa')
                      postUpdateConsecutivo(updateCon).then((res)=>{
                        //console.log(res.data,'ultimo consecutivoooo')
                        setmodalOnSeleccionServicio(false)
                        setmodalOnConfirmar(false)
                      })
                
                      
        
                      passChildCambioDeEstado({
                        estadoPaciente:'2',
                        disabledPendiente:true,
                        disabledReservado:true,
                        disabledConfirmado:true,
                        disabledIngresoSala:false,
                        disabledPreparado:true,
                        disabledCirugia:true,
                        disabledRecuperacion:true,
                        disabledSalida:true,
                        disabledCancelar:false,
                        disabledRealizada:true,
                        disabledFacturada:true
                      })
                   
            }
        }else{
          setmodalOnNoTieneProcedimiento(true)
        }
        
           
          
        }
        
        
    
        
    
    
      
    return (
        <>
        <tr className="bg-white border-b">
          <td className="text-xs text-gray-900 font-medium px-6 py-4 whitespace-pre-wrap">
          <button type="button"
          onClick={handleOnclickConfirmarConsecutivo}
                className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
                Confirmar
              </button>
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4 whitespace-pre-wrap">
            {item.TmCtvIng? item.TmCtvIng:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4 whitespace-pre-wrap">
            {item.TFFchI? item.TFFchI.split(' ')[0]:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
            {parseInt(item.ClaPro) === 3? 'Urgencias':null}
            {parseInt(item.ClaPro) === 1? 'Ambulatorio':null}
            {parseInt(item.ClaPro) === 2? 'Hospitalización':null}
            {parseInt(item.ClaPro) === 4? 'Tratamiento Especial':null}
          </td>
          
        </tr>
        {modalOnVerificarMedico? <ModalConfirmarMedicoProcedimiento setmodalOnVerificarMedico={setmodalOnVerificarMedico} procedimientosNoTinenenMedico={procedimientosNoTinenenMedico}/>:null}
        {modalOnNoTieneProcedimiento && <ModalNoTieneProcedimientosQX setmodalOnNoTieneProcedimiento={setmodalOnNoTieneProcedimiento}/>}
        </>
  )
}

export default TablaSeleccionServicioAmbulatorio